module.exports = __webpack_public_path__ + "img/1-2.5ff88c0d.webp";